import _objectSpread from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import "core-js/modules/es6.string.starts-with";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";
import router from "./routers";
import store from '@/store';
import Config from '@/settings';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken, setToken } from '@/utils/auth'; // getToken from cookie
import { buildMenus } from '@/api/system/menu';
import { getAuthDinLogin, getAuthDinAuthCodeLogin } from '@/api/system/user';
import { getParamsFromUrl, requestAuthCode } from '@/utils/index';
import { filterAsyncRouter, firstRedirectRouter } from '@/store/modules/permission';
import { filterMatchMenu, getSubMenusTitle } from "./resetMenuData";
import { toFileManage } from "./qiankunFun";
import actions from '@/micro/actions';
import Layout from '@/layout';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login']; // no redirect whitelist
var rawAppendChild = HTMLHeadElement.prototype.appendChild;
var rawAddEventListener = window.addEventListener;
var closeSelectedTag = function closeSelectedTag(view, newView) {
  store.dispatch("tagsView/delView", view).then(function (_ref) {
    var visitedViews = _ref.visitedViews;
    // 新增关闭当前页是返回上一个tab页，第二个参数传目标path
    newView ? router.push(newView) : toLastView(visitedViews, view);
  });
};
var toLastView = function toLastView(visitedViews, view) {
  var latestView = visitedViews.slice(-1)[0];
  if (latestView) {
    router.push(latestView);
  } else {
    // now the default is to redirect to the home page if there is no tags-view,
    // you can adjust it according to your needs.
    if (view.name === "Dashboard") {
      // to reload home page
      router.replace({
        path: "/redirect" + view.fullPath
      });
    } else {
      router.push("/");
    }
  }
};
router.beforeEach(/*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(to, from, next) {
    var title;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          // 从子项目跳转到主项目
          if (Config.childrenApplications.some(function (item) {
            return to.path.startsWith(item);
          })) {
            title = getSubMenusTitle(to.path);
            document.title = title + ' - ' + Config.title;
          } else {
            if (to.meta.title) {
              document.title = to.meta.title + ' - ' + Config.title;
            }
          }

          // 从子项目跳转到主项目
          if (Config.childrenApplications.some(function (item) {
            return from.path.startsWith(item);
          }) && !Config.childrenApplications.some(function (item) {
            return to.path.startsWith(item);
          })) {
            HTMLHeadElement.prototype.appendChild = rawAppendChild;
            window.addEventListener = rawAddEventListener;
          }
          NProgress.start();
          // store.commit('SET_CHILDREN', false)
          if (getToken()) {
            console.log("%c 主应用路由==to==>" + to.path, 'color: red;font-size:24px;font-weight: bold;text-decoration: underline;');
            // 主应用向子应用传递token
            actions.setGlobalState({
              token: getToken(),
              LOGIN_OUT: function LOGIN_OUT() {
                // 暴露函数退出登录
                store.dispatch('LogOut').then(function () {
                  location.reload();
                });
              },
              UPDATE_WORK_STATUS: function UPDATE_WORK_STATUS(val) {
                store.commit('tagsView/SET_WORK_STATUS', val);
              },
              //暴露方法给子应用跳转主应用路由
              SET_CHANGE_ROUTER: function SET_CHANGE_ROUTER(val) {
                router.push(val);
              },
              user: store.getters.user || [],
              roles: store.getters.roles || [],
              CloseCurrentTag: function CloseCurrentTag(res, res2) {
                closeSelectedTag(res, res2);
              },
              ToFileManage: toFileManage
            });
            // 已登录且要跳转的页面是登录页
            if (to.path === '/login') {
              if (to.query.path === 'offlineAlarm') {
                next({
                  path: '/offlineAlert'
                });
              } else {
                next({
                  path: '/'
                });
              }
              NProgress.done();
            } else {
              if (store.getters.roles.length === 0) {
                // 判断当前用户是否已拉取完user_info信息
                store.dispatch('GetInfo').then(function () {
                  // 拉取user_info
                  // 动态路由，拉取菜单
                  loadMenus(next, to);
                }).catch(function () {
                  store.dispatch('LogOut').then(function () {
                    location.reload(); // 为了重新实例化vue-router对象 避免bug
                  });
                });
                // 登录时未拉取 菜单，在此处拉取
              } else if (store.getters.loadMenus) {
                // 修改成false，防止死循环
                store.dispatch('updateLoadMenus');
                loadMenus(next, to);
              } else {
                // store.dispatch('setChildrenFlag', true)
                next();
              }
            }
          } else {
            /* has no token*/
            if (whiteList.indexOf(to.path) !== -1) {
              // 在免登录白名单，直接进入
              next();
            } else {
              next("/login?redirect=".concat(to.fullPath)); // 否则全部重定向到登录页
              NProgress.done();
            }
          }
        case 1:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}());
export var loadMenus = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(next, to) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          buildMenus().then(/*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
              var menus, sdata, rdata, sidebarRoutes, rewriteRoutes, redirectItem, redirectRouter;
              return _regenerator().w(function (_context2) {
                while (1) switch (_context2.n) {
                  case 0:
                    if (!(res.code === 200)) {
                      _context2.n = 2;
                      break;
                    }
                    _context2.n = 1;
                    return filterMatchMenu(res.data);
                  case 1:
                    menus = _context2.v;
                    sdata = JSON.parse(JSON.stringify(menus));
                    rdata = JSON.parse(JSON.stringify(menus));
                    sidebarRoutes = filterAsyncRouter(sdata);
                    rewriteRoutes = filterAsyncRouter(rdata, true);
                    console.log('sidebarRoutes', sidebarRoutes);
                    console.log('rewriteRoutes', rewriteRoutes);
                    redirectItem = firstRedirectRouter(sidebarRoutes); // console.log('firstRedirectRouter', redirectItem)
                    if (redirectItem) {
                      redirectRouter = {
                        path: '/',
                        component: Layout,
                        redirect: redirectItem.path,
                        hidden: true,
                        children: [redirectItem]
                      };
                      rewriteRoutes.push(redirectRouter);
                      sidebarRoutes.push(redirectRouter);
                    }
                    // rewriteRoutes.push({ path: '*', redirect: '/404', hidden: true })
                    store.dispatch('GenerateRoutes', rewriteRoutes).then(function () {
                      // 存储路由
                      router.addRoutes(rewriteRoutes); // 动态添加可访问路由表
                      next(_objectSpread(_objectSpread({}, to), {}, {
                        replace: true
                      }));
                    });
                    store.dispatch('SetSidebarRouters', sidebarRoutes);
                  case 2:
                    return _context2.a(2);
                }
              }, _callee2);
            }));
            return function (_x6) {
              return _ref4.apply(this, arguments);
            };
          }());

          // const menus = await filterMatchMenu()
          // const sdata = JSON.parse(JSON.stringify(menus))
          // const rdata = JSON.parse(JSON.stringify(menus))
          // const sidebarRoutes = filterAsyncRouter(sdata)
          // const rewriteRoutes = filterAsyncRouter(rdata, true)
          // console.log('sidebarRoutes', sidebarRoutes)
          // console.log('rewriteRoutes', rewriteRoutes)
          // // rewriteRoutes.push({ path: '*', redirect: '/404', hidden: true })
          // store.dispatch('GenerateRoutes', rewriteRoutes).then(() => { // 存储路由
          //     router.addRoutes(rewriteRoutes) // 动态添加可访问路由表
          //     next({ ...to, replace: true })
          // })
          // store.dispatch('SetSidebarRouters', sidebarRoutes)
        case 1:
          return _context3.a(2);
      }
    }, _callee3);
  }));
  return function loadMenus(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();
router.afterEach(function () {
  NProgress.done(); // finish progress bar
});